import { render } from "./ConnectHIS.vue?vue&type=template&id=6980729c&scoped=true"
import script from "./ConnectHIS.vue?vue&type=script&lang=js"
export * from "./ConnectHIS.vue?vue&type=script&lang=js"

import "./ConnectHIS.vue?vue&type=style&index=0&id=6980729c&lang=scss&scoped=true"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6980729c"]])

export default __exports__